import React, { useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Input, Button, message } from 'antd'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

export const Send = ({ t, views, setAddView }) => {

    const [messageApi, contextHolder] = message.useMessage()
    const navigate = useNavigate()
    const [name, setName] = useState("")
    const [loading, setLoading] = useState(false)

    const createView = async() => {
        if(name === "") {
            messageApi.info(t("add_name_view"))
        }
        else if(views.length===0) {
            messageApi.info(t("add_one_report"))
        }
        else {
            setLoading(true)

            const arr = []
            views.forEach((graph) => {
                arr.push(graph._id)
            })

            const data = {
                name_view: name,
                reports_id: arr
            }

            try {
                const res = await axios.post(config.urlApi + "/private/views", data)
                if(res.status === 201) {
                    messageApi.success(t("success_create_view"))
                    setLoading(false)
                    setAddView(false)
                }
            }
            catch (error) {
                setLoading(false)
                if(error.status === 413) {
                    messageApi.error(t("error_413_views"))
                }
                else if (error.status === 401) {
                    navigate("/")
                }
                else {
                    messageApi.error(t("error_create_view"))
                }
            }
        }
    }

    return (
        <Flex justify="space-between" align="center" style={{ width: "100%", height: "auto", padding: "10px 0" }}>
            <Input onChange={(e) => setName(e.target.value)} value={name} placeholder="Nombre de la vista" style={{ width: "55%" }} />
            <Button onClick={createView} loading={loading} ghost style={{ width: "10%", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }}>{t("create")}</Button>

            {contextHolder}
        </Flex>
    )
}
